import * as PaddingViews from '../util/padding_views';
import { useEffect }     from 'react';
import { useRef }        from 'react';
import React             from 'react';

export default function WithoutPaddingInViews({ children, className, position }) {
  const element = useRef(null);

  useEffect(() => {
    const el = element.current;
    if (el) {
      PaddingViews.remove(el, position);
      PaddingViews.add(el, position);
    }

    return () => {
      PaddingViews.remove(el, position);
    };
  });

  return (
    <div className={className} ref={element}>
      {children}
    </div>
  );
}
